
export default {
    recipientList: []
  }
  